<template>
  <ul
    :id="id"
    :class="['nav mb-2', variant && `nav-${variant}`, {'nav-fill': fill}]"
    role="tablist"
  >
    <li v-if="all" class="nav-item" role="presentation">
      <button
        id="all"
        :class="['nav-link', {active: active === undefined}]"
        type="button"
        role="tab"
        :aria-selected="active === undefined"
        @click="$emit('update:active', undefined)"
      >
        All
      </button>
    </li>
    <li v-for="(n, index) in nav" :key="index" class="nav-item" role="presentation">
      <button
        :id="n.id"
        :class="['nav-link', {active: n.id === active?.id}]"
        type="button"
        role="tab"
        :aria-selected="n.id === active?.id"
        :disabled="n.disabled"
        class="d-flex gap-2 align-items-center"
        @click="$emit('update:active', n)"
      >
        {{ n.title }}
        <Icon v-if="n.icon" :icon="`material-symbols:${n.icon}`" />
      </button>
    </li>
  </ul>
</template>
<script lang="ts" setup>
import {
  type BootstrapNavProps,
  type BootstrapNavItem,
} from '@/components/shared/bootstrap/BootstrapNav/BootstrapNav.types';
const {
  id,
  nav,
  active,
  variant = undefined,
  fill = false,
  all = false,
} = defineProps<BootstrapNavProps>();
defineEmits<{'update:active': [navItem: BootstrapNavItem | undefined]}>();
</script>
